// 新闻原始 feed prompt 块（项目级近期新闻，喂给 AI 提取语义信号）
// 注意：此块只输出 raw news 列表；news_signals JSON schema 已在主 prompt 中写明

export function buildPromptBlock(project, a) {
  const news = project?.surfNews;
  if (!news) return '';
  const all = [...(news.trending || []), ...(news.recent || [])];
  const dedup = Array.from(new Map(all.map(n => [n?.title, n])).values())
                     .filter(n => n?.title).slice(0, 12);
  if (!dedup.length) return '【近期新闻摘要】无新闻数据';
  const lines = ['【近期新闻摘要（Surf 14日内，用于提取 news_signals）】'];
  dedup.forEach(n => {
    const ts = n.published_at ? new Date(n.published_at * 1000).toISOString().slice(0, 10) : '?';
    lines.push(`[${ts}] ${n.source || '?'}: ${n.title}`);
  });
  return lines.join('\n');
}
